import * as React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import { Tabs, Tab, Box, AppBar } from "@material-ui/core";
import WhList from "./WhList";
import ResList from "./ResList";
import AltPnList from "./AltPnList";
import RnList from "./RnList";

const useStyles = makeStyles({
  root: { width: "100%", margin: "auto" },
  spacer: { height: 20 },
});

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const WarehouseInfo = (props: any) => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Card className={classes.root}>
      <CardContent>
        <AppBar position="static">
          <Tabs value={value} onChange={handleChange} aria-label="Warehouse Info">
            <Tab label="WH" {...a11yProps(0)} />
            <Tab label="RES" {...a11yProps(1)} />
            <Tab label="ALT. PN" {...a11yProps(2)} />
            <Tab label="RN" {...a11yProps(3)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
          <WhList pn={props.pn} isPbh={props.isPbh} requestId={props.requestId} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ResList pn={props.pn} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <AltPnList pn={props.pn} />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <RnList pn={props.pn} relationCode={props.customerCode} />
        </TabPanel>
      </CardContent>
    </Card>
  );
};

export default WarehouseInfo;
